module.exports = __webpack_public_path__ + "img/icon_reserv_fav.bafef4ba.svg";